export enum InternalMessageType {
    AddToCart = 'addToCart',
    AddToCartResponse = 'addToCartResponse',
    CloseDialog = 'closeDialog',
}
